export enum JsonFieldType {
  STRING = 'string',
  NUMBER = 'number',
  INTEGER = 'integer',
  BOOLEAN = 'boolean',
  ARRAY = 'array',
  OBJECT = 'object',
  NULL = 'null',
  VOID = 'void',
  FILE = 'file',
  REFERENCE = 'reference',
  INTERNAL_REFERENCE = 'internal-reference',
  FOLDER_STRUCTURE = 'folder-structure',
}

export enum JsonFormat {
  EMAIL = 'email',
  DATE_TIME = 'date-time',
  DATE = 'date',
  URI = 'uri',
  PASSWORD = 'password',
  UUID = 'uuid',
  DURATION = 'duration',
}

export enum ReferenceType {
  USER = 'USER',
  ORGANIZATION = 'ORGANIZATION',
  MODEL_INSTANCE = 'MODEL_INSTANCE',
  INTERNAL_REFERENCE = 'INTERNAL_REFERENCE',
}

export interface XReference {
  type: ReferenceType;
  fetch?: 'EAGER' | 'LAZY';
  modelIds?: string[];
}

export interface IJSONSchemaField {
  type: JsonFieldType;

  // common constraints
  title?: string;
  description?: string;
  default?: any;
  examples?: any[];

  // string specific constraints
  minLength?: number;
  maxLength?: number;
  pattern?: string;
  format?: JsonFormat;

  // number specific constraints
  minimum?: number;
  maximum?: number;
  exclusiveMinimum?: number;
  exclusiveMaximum?: number;
  multipleOf?: number;

  // array specific constraints
  items?: IJSONSchemaField | IJSONSchemaField[];
  additionalItems?: boolean | IJSONSchemaField;
  minItems?: number;
  maxItems?: number;
  uniqueItems?: boolean;
  'x-unique'?: string[];

  // object specific constraints
  properties?: Record<string, IJSONSchemaField>;
  required?: string[];
  additionalProperties?: boolean | IJSONSchemaField;
  minProperties?: number;
  maxProperties?: number;
  patternProperties?: Record<string, IJSONSchemaField>;
  dependencies?: Record<string, IJSONSchemaField | string[]>;

  // combinators
  allOf?: IJSONSchemaField[];
  anyOf?: IJSONSchemaField[];
  oneOf?: IJSONSchemaField[];
  not?: IJSONSchemaField;

  // enum
  enum?: string[];
  const?: any;

  // extensions
  [key: string]: any;
}

export interface IJSONSchema extends IJSONSchemaField {
  // Meta from JSON Schema standard
  $id?: string;
  $schema?: string;
  $ref?: string;

  // Recursive fields
  properties?: Record<string, IJSONSchema>;
  required?: string[];

  items?: IJSONSchema | IJSONSchema[];
  additionalItems?: boolean | IJSONSchema;

  additionalProperties?: boolean | IJSONSchema;
  patternProperties?: Record<string, IJSONSchema>;
  dependencies?: Record<string, IJSONSchema | string[]>;

  // Definitions / reusable blocks
  $defs?: Record<string, IJSONSchema>; // Draft-2020-12

  // Combinators
  allOf?: IJSONSchema[];
  anyOf?: IJSONSchema[];
  oneOf?: IJSONSchema[];
  not?: IJSONSchema;
}

export interface IPaginateData<T> {
  data: T[];
  meta: {
    page: number;
    size: number;
    pages: number;
    total: number;
  };
}

export interface ICursorPaginateData<T> {
  data: T[];
  hasNext: boolean;
  hasPrev: boolean;
}

export interface IPaginateParams {
  page?: number | null;
  size?: number | null;
}

export interface ISortParams {
  sortName?: string | null;
  sortOrder?: string | null;
  sort?: string | null;
}

export interface ISearchParams {
  search?: string | null;
}

export interface IBaseTableParams
  extends IPaginateParams,
    ISortParams,
    ISearchParams {}

export interface ICursorPaginateMeta {
  page: number;
  pages: number;
  size: number;
  total: number;
}
